import { AxiosResponse } from 'axios';
import AxiosInstance from './AxiosInstance';

export const getLicenses = async (): Promise<AxiosResponse> => AxiosInstance.get('licenses.maxActiveUsers');
